export default {
	// When the bound element is inserted into the DOM...
	inserted: function (el, binding) {
		const label = binding.value;

		// Create the label element and set its text content
		const labelElement = document.createElement('span');
		labelElement.textContent = label;
		labelElement.classList.add('label');
		labelElement.style.opacity = '0';

		// Add event listeners for mouseenter and mouseleave
		el.addEventListener('mouseenter', () => {
			labelElement.style.opacity = '1';
			el.classList.remove('v-btn--fab', 'v-btn--round');
			el.classList.add('v-btn--rounded');
			el.appendChild(labelElement); // Append the label element on mouseenter
		});
		el.addEventListener('mouseleave', () => {
			labelElement.style.opacity = '0';
			el.classList.add('v-btn--fab', 'v-btn--round');
			el.classList.remove('v-btn--rounded');
			el.removeChild(labelElement); // Remove the label element on mouseleave
		});
	}
};